import { render } from "./ranking.vue?vue&type=template&id=0d6cbbc4&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"

import "./ranking.vue?vue&type=style&index=0&id=0d6cbbc4&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6cbbc4"]])

export default __exports__